import { useMemo } from "react";
import { useEntryGroupsCache, useMattersCache } from "@/shared/cache";
import { buildDailySums } from "@/v2/lib/daySums";
import Calendar from "./Calendar";

export default function CalendarPage() {
	const { matters } = useMattersCache();
	const { entries } = useEntryGroupsCache(matters);
	const dailySums = useMemo(() => buildDailySums(entries), [entries]);
	return <Calendar dailySums={dailySums} />;
}
